import { api } from "./api";

export async function GET_PAGE(uuid: string) : Promise<any[]>{
    const {data} = await api.get(`/pages/${uuid}/details`)
    return data;
}

export async function CREATE_PAGE(type: string, params: any) : Promise<any[]>{
    const {data} = await api.post(`/pages/${type}`, params)
    return data.page;
}